import ApiBaseService from "services/ApiBaseService.js";

class DoctorFormService {
  static addAssessmentForm([hospitalId, patientId, data]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms`,
      "POST",
      data
    );
  }

  static createStimFormFromAssessment([hospitalId, patientId, assessmentFormId]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/from-assessment/${assessmentFormId}`,
      "POST",
      {}
    );
  }

  static getAssessmentForms([hospitalId, patientId]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms`,
      "GET"
    );
  }

  static getAssessmentForm(hospitalId, patientId, formId) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}`,
      "GET"
    );
  }

  static saveAssessmentForm(hospitalId, patientId, formId, data) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}`,
      "PUT",
      data
    );
  }

  static submitAssessmentForm(hospitalId, patientId, formId) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}`,
      "POST",
      {}
    );
  }

  static deleteAssessmentForm([hospitalId, patientId, formId]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}`,
      "DELETE"
    );
  }

  static revokeAssessmentFormSubmission([hospitalId, patientId, formId]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}/revoke`,
      "POST"
    );
  }

  static getAssessmentAnalysis([hospitalId, patientId]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/analysis`,
      "GET"
    );
  }

  static getStimFormReportData([hospitalId, patientId, formId]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}/stim-report-data`,
      "GET"
    );
  }

  static emailAssessmentReport([hospitalId, patientId, formId]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}/email-assessment-report`,
      "POST"
    );
  }

  static emailProgressReport([hospitalId, patientId, formId]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}/email-progress-report`,
      "POST"
    );
  }

  static getAssessmentProgressReportData([hospitalId, patientId, formId]) {
    return ApiBaseService.request(
      `hospitals/${hospitalId}/patients/${patientId}/assessment-forms/${formId}/progress-report-data`,
      "GET"
    );
  }
}

export default DoctorFormService;
